(function ($) {

    $(document).ready(function () {

        // Open mobile menu
        $('.navbar-toggle').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('collapsed')) {
                $('.header').addClass('mobile-activated-menu');
                $('body').addClass('overflow-hidden'); // block scroll
            } else {
                $('.header').removeClass('mobile-activated-menu');
                $('body').removeClass('overflow-hidden');
            }
        });
    });

})(jQuery);